import { debounce } from '@mobi/utils/functions'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'
import type { RaceCodesLowerCase } from '../Racing/Types/MeetingInformation'
import type { SkyVideoPlayerState } from './Store'

export const trackVisionOpened = (
  opts: { channel: SkyVideoPlayerState['selectedChannel'] } & (
    | { openLocation: 'bottom-navigation'; headerState?: never }
    | { openLocation: 'race-card' | 'form'; headerState: 'sticky' | 'default' }
    | { openLocation: 'sky-page'; headerState?: 'sticky' | 'default' }
  ) & { raceCode?: RaceCodesLowerCase }
) => {
  trackEvent(keys.visionOpened, opts)
}

export const trackVisionClosed = () => {
  trackKey(keys.visionClosed)
}

export const trackFullScreen = debounce((isFullscreen: boolean) => {
  isFullscreen ? trackKey(keys.visionFullScreenOn) : trackKey(keys.visionFullScreenOff)
}, 1000)

export const trackVisionMute = debounce((isMuted: boolean) => {
  isMuted ? trackKey(keys.visionMuted) : trackKey(keys.visionUnMuted)
}, 1000)

export const trackSelectedChannel = (channel: SkyVideoPlayerState['selectedChannel']) => {
  const visionKeys: Record<SkyVideoPlayerState['selectedChannel'], EventKey> = {
    Sky1: keys.visionSky1Selected,
    Sky2: keys.visionSky2Selected,
    RacingWA: keys.visionRacingWASelected,
    Replay: keys.visionRaceReplaySelected,
  }
  trackKey(visionKeys[channel])
}

// =====
// Types
// =====

type EventKey =
  | typeof keys.visionSky1Selected
  | typeof keys.visionSky2Selected
  | typeof keys.visionRacingWASelected
  | typeof keys.visionRaceReplaySelected
